var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-breadcrumb-cartao',{attrs:{"titulo":"Gestão de Recursos e Serviços Próprios","breadcrumb":_vm.bread,"iconeSvg":_vm.RecursosPropriosSvg}},[_c('TabelaRecursosProprios')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }